export default {
  // serverURI: 'http://localhost:8080',
  // websocketURI: 'ws://localhost:8080',
  // serverURI: 'http://192.168.86.42:8080',
  // websocketURI: 'ws://192.168.86.42:8080',
  // appURI: 'http://localhost:3000',
  // appURI: 'http://192.168.86.42:3000',
  Traccar_URI: process.env.Traccar_URI,
  serverURI: process.env.SERVER_URI,
  trip_serverURI: process.env.TRIP_SERVER_URI,
  websocketURI: process.env.WEBSOCKET_URI,
  appURI: process.env.APP_URI,
  fixedLayout: false,
  hideLogoOnMobile: false,
  driverApkUrl: process.env.DRIVER_APP_APK_URL,
  surveyApkUrl: process.env.SURVEY_APP_APK_URL
};

/**
 * Adding a property to this object will create a repository for that property.
 * Ex: user: { alias: 'user' } will create $visitorRepository accessible in each component's "this".
 * */
export const resources = {
  user: {
    alias: "user",
    associations: {
      groups: {
        alias: "group",
      },
      permissions: {
        alias: "permission",
      },
      connections: {
        alias: "connection",
      },
      conversations: {
        alias: "conversation",
      },
      notifications: {
        alias: "notification",
      },
      documents: {
        alias: "document",
      },
      sharedDocuments: {
        alias: "shared-document",
      },
      images: {
        alias: "image",
      },
    },
  },
  conversation: {
    alias: "conversation",
  },
  notification: {
    alias: "notification",
  },
  connection: {
    alias: "connection",
  },
  auditLog: {
    alias: "auditLog",
    options: {
      filterDeleted: false,
    },
  },
  document: {
    alias: "document",
    associations: {
      users: {
        alias: "user",
      },
    },
  },
  image: {
    alias: "image",
  },
  visitor: {
    alias: "visitor",
  },
  city: {
    alias: "city/list",
    associations: {
      users: {
        alias: "user",
      },
    },
  },
  role: {
    alias: "role",
    associations: {
      users: {
        alias: "user",
      },
      permissions: {
        alias: "permission",
      },
    },
  },
  group: {
    alias: "group",
    associations: {
      users: {
        alias: "user",
      },
      permissions: {
        alias: "permission",
      },
    },
  },
  permission: {
    alias: "permission",
    associations: {
      users: {
        alias: "user",
      },
      roles: {
        alias: "role",
      },
      groups: {
        alias: "group",
      },
    },
  },
  deviceData: {
    alias: "device",
  },
  transportData: {
    alias: "transport",
  },
  segregationData: {
    alias: "segregation",
  },
  dumpyardData: {
    alias: "dumpyard",
  },
  vehicleData: {
    alias: "vehicle",
  },
  fuelExpenseData: {
    alias: "fuelExpense",
  },
  miscellaneousData: {
    alias: "miscellaneous/list",
  },
  dailyWagesData: {
    alias: "daily-wages/list",
  },
  wasteRecyclesData: {
    alias: "wasteRecycles",
  },
  vehicleMaintenanceData: {
    alias: 'vehicle-maintenance/list'
  },
  surveyData: {
    alias: 'survey/list'
  },
  houseData: {
    alias: "house/list",
  },
  houseByIdData: {
    alias: "waste-division-area/housesById",
  },
  vendorData: {
    alias: "vendor/list",
  },
  vendorDataList: {
    alias: "vendor",
  },
  wastetypeData: {
    alias: "waste-type/list",
  },
  helperAndDriverData: {
    alias: "helperanddriver",
  },
  wasteSegregationData: {
    alias: "wasteSegregation",
  },
  wastecollectionareaData: {
    alias: "waste-collection",
  },
  regionData: {
    alias: "region",
  },
  regionsData: {
    alias: "regions",
  },
  vehicleData: {
    alias: "vehicle",
  },
  staffData: {
    alias: "staff",
  },
  siteData: {
    alias: "site",
  },
  tripData: {
    alias: "trip",
  },
  transferTripData: {
    alias: 'trip/secondary-trip'
  },
  triprouteData: {
    alias: "triproute",
  },
  driverData: {
    alias: "driver",
  },
  salesdataData: {
    alias: "salesdata",
  },
  tripdetailsData: {
    alias: "tripdetails",
  },
  tripExceptionData: {
    alias: "tripException",
  },
  triplocationData: {
    alias: "triplocation",
  },
  reportgenerationData: {
    alias: "reportgeneration",
  },
  schedulereportData: {
    alias: "schedulereport",
  },
  expiringLicenseData: {
    alias: "expiringLicense",
  },
  livedetailsData: {
    alias: "livedetails",
  },
  tempuserData: {
    alias: "tempuser",
  },
  reportScheduleReminderData: {
    alias: "reportScheduleReminder",
  },
  reportData: {
    alias: "report",
  },
  techchecklistData: {
    alias: "techchecklist",
  },
};

export const API = {
  SEGREGATION: resources.segregationData.alias || 'segregation',
  DUMPYARD: resources.dumpyardData.alias || 'dumpyard',
  TRANSPORT: resources.transportData.alias || 'transport',
  USER: resources.user.alias || 'user',
  PERMISSION: resources.permission.alias || 'permission',
  CITY: resources.city.alias || 'city',
  VEHICLEMAINTENANCE: resources.vehicleMaintenanceData.alias || 'vehicleMaintenance'

}

export const REQUIRED_PASSWORD_STRENGTH = 3;

export const USER_ROLES = {
  REPORT_STAFF: "Report Staff",
  SALES_MANAGER: "Sales Manager",
  JOURNEY_MANAGER: "Journey Manager",
  GA_HEAD: "GA Head",
  ADMIN: "Admin",
  SUPER_ADMIN: "Super Admin",
};

export const PERMISSION_STATES = {
  INCLUDED: "Included",
  EXCLUDED: "Excluded",
  FORBIDDEN: "Forbidden",
};

export const RESPONSE_MESSAGES = {
  EXPIRED_ACCESS_TOKEN: "Expired Access Token",
  EXPIRED_REFRESH_TOKEN: "Expired Refresh Token",
};

export const EVENTS = {
  USER_PERMISSIONS_UPDATED: "user-permissions-updated",
  USER_PERMISSIONS_SAVED: "user-permissions-saved",
  USER_GROUPS_UPDATED: "user-groups-updated",
  USER_GROUPS_SAVED: "user-groups-saved",
  GROUP_USERS_UPDATED: "group-users-updated",
  GROUP_USERS_SAVED: "group-users-saved",
  GROUP_PERMISSIONS_UPDATED: "group-permissions-updated",
  GROUP_PERMISSIONS_SAVED: "group-permissions-saved",
  PERMISSION_USERS_UPDATED: "permission-users-updated",
  PERMISSION_USERS_SAVED: "permission-users-saved",
  PERMISSION_GROUPS_UPDATED: "permission-groups-updated",
  PERMISSION_GROUPS_SAVED: "permission-groups-saved",
  PASSWORD_SCORE_UPDATED: "password-score-updated",
  UPDATING_PASSWORD_SCORE: "updating-password-score",

  DATA_REQUESTED: "data-requested",
  DATA_READY: "data-ready",
  CLEAR_REQUESTED: "clear-requested",

  OPEN_CHAT: "open-chat",
  CLOSE_CHAT: "close-chat",
  OPEN_CHAT_CREATE: "open-chat-create",
  CLOSE_CHAT_CREATE: "close-chat-create",

  MARK_CONVERSATION_AS_READ: "mark-conversation-as-read",
  MARK_CONVERSATION_AS_UNREAD: "mark-conversation-as-unread",

  MARK_NOTIFICATION_AS_READ: "mark-notification-as-read",
  MARK_NOTIFICATION_AS_UNREAD: "mark-notification-as-unread",
};

export const NOTIFICATION_TYPES = {
  SHARED_DOCUMENT: "shared-document",
  FOLLOW: "follow",
  CONTACT: "contact",
};

export const CHAT_TYPES = {
  DIRECT: "direct",
  GROUP: "group",
};



// WEBPACK FOOTER //
// ./src/config/index.js